import { mailMergeTagOptions } from '../../../Discover/Core/models/merge-tag-options.const';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';
import { TextDisplayElementModel } from './text-display-element.model';


export class RichTextDisplayElementModel extends TextDisplayElementModel {

    enablePersonalizations: boolean = true;
    enableLineHeight: boolean = true;
    enableHeading: boolean = true;
    enableFontColor: boolean = true;
    enableBackgroundColor: boolean = true;
    enableHtmlEditor: boolean = true;
    enableAIHelper: boolean = false;
    enableAIRefinement: boolean = false;
    enableFontFamily: boolean = true;
    enableFontSize: boolean = true;
    enableAlignment: boolean = true;
    enableInsertImage: boolean = true;
    enableStrikethrough: boolean = true;
    enableNumberedList: boolean = true;
    enableBlockQuote: boolean = true;
    enableDirection: boolean = true;
    enableIndent: boolean = true;
    enableTranslation: boolean = false;
    allowImage: boolean = true;
    pastePlainText: boolean = false;
    aiReferenceId: string;
    mergeTagOptions: DropdownOptionModel[] = mailMergeTagOptions;

    constructor(
        content?: string,
        styles?: any,
    ) {
        super(content, styles);
    }

    clone(): RichTextDisplayElementModel {
        const clone = new RichTextDisplayElementModel(
            this.text,
            this.styles && this.styles.clone ? this.styles.clone() : JSON.parse(JSON.stringify(this.styles))
        );

        clone.enablePersonalizations = this.enablePersonalizations;
        clone.enableLineHeight = this.enableLineHeight;
        clone.enableHeading = this.enableHeading;
        clone.enableFontColor = this.enableFontSize;
        clone.enableBackgroundColor = this.enableBackgroundColor;
        clone.enableAIHelper = this.enableAIHelper;
        clone.enableAIRefinement = this.enableAIRefinement;
        clone.enableFontFamily = this.enableFontFamily;
        clone.enableFontSize = this.enableFontSize;
        clone.enableInsertImage = this.enableInsertImage;
        clone.enableStrikethrough = this.enableStrikethrough;
        clone.enableNumberedList = this.enableNumberedList;
        clone.enableAlignment = this.enableAlignment;
        clone.enableBlockQuote = this.enableBlockQuote;
        clone.enableDirection = this.enableDirection;
        clone.enableIndent = this.enableIndent;
        clone.enableTranslation = this.enableTranslation;
        clone.allowImage = this.allowImage;
        clone.pastePlainText = this.pastePlainText;
        clone.aiReferenceId = this.aiReferenceId;

        return clone;
    }
}
